import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/evcs_ecmp_orders',
  component: Management,
  redirect: '/evcs_ecmp_orders/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/evcs_ecmp_orders/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvcsEcmpOrders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_ecmp_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsEcmpOrders,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
